// extracted by mini-css-extract-plugin
module.exports =  {"notes-hero-buttons":"Notes-E5kl__notes-hero-buttons","notes-overview":"Notes-ILs0__notes-overview"};